export default __webpack_public_path__ + "static/SFMono-Regular-04c2f44851d26268afe8f56503f5b672.ttf";